import ClientGroupsPage from './ClientGroupsPage';

export default ClientGroupsPage;
